import { RouteRecordRaw } from "vue-router";

const mfRoutes: RouteRecordRaw[] = [
  {
    path: "/mf/game-category/:id?/:name?",
    component: () => import("../views/mf/MfGameCategoryView.vue"),
  },
  {
    path: "/mf/game/:id/:name?",
    component: () => import("../views/mf/MfGameView.vue"),
  },
  {
    path: "/mf/worksheets",
    component: () => import("../views/mf/MfWorksheetsView.vue"),
  },
  {
    name: "MfWorksheets",
    path: "/mf/worksheets/:cat/:year/:catName",
    component: () => import("../views/mf/MfWorksheetsView.vue"),
  },
  {
    path: "/mf/search",
    component: () => import("../views/mf/MfSearchView.vue"),
  },
  {
    path: "/mf/join-sf",
    component: () => import("../views/mf/MfJoinSfView.vue"),
  },
];

export default mfRoutes;
